import { apiSlice } from "../../app/api/apiSlice";

export const universityApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    tagTypes: ["Students", "Student"],
    importStudentsUniversity: builder.mutation({
      query: (payload) => ({
        url: "/student/bus/universities",
        method: 'POST',
        body: { ...payload },
      }),
      invalidatesTags: ['Student', 'Students'],
    })
  }),
  overrideExisting: true,
})

export const {
  useImportStudentsUniversityMutation,
} = universityApiSlice